import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { trackPurchase } from '../lib/metaPixel';

function PurchaseSuccess() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const sessionId = searchParams.get('session_id');
        if (!sessionId) {
            setStatus('missing');
            return undefined;
        }

        let cancelled = false;

        async function confirmAndTrack() {
            try {
                const response = await fetch(
                    `/api/checkout-session?session_id=${encodeURIComponent(sessionId)}`
                );
                const data = await response.json();
                if (cancelled) return;
                if (data.paid && data.eventId) {
                    trackPurchase(data.eventId, {
                        value: data.value,
                        currency: data.currency,
                    });
                    setStatus('paid');
                    return;
                }
                setStatus('unpaid');
            } catch (error) {
                if (!cancelled) {
                    setStatus('error');
                }
            }
        }

        confirmAndTrack();
        return () => {
            cancelled = true;
        };
    }, [searchParams]);

    const heading =
        status === 'paid'
            ? 'Thank you for your order'
            : status === 'unpaid'
                ? 'Payment still processing'
                : status === 'missing'
                    ? 'Order confirmation'
                    : status === 'error'
                        ? 'Thanks — we are confirming your order'
                        : 'Confirming your order';

    const message =
        status === 'paid'
            ? 'Your EpiQCase order is confirmed. You will receive a receipt from Stripe by email.'
            : status === 'unpaid'
                ? 'If you just checked out, your payment may still be processing. You will get an email receipt when it completes.'
                : status === 'missing'
                    ? 'If you completed checkout, Stripe will email your receipt. Set the Buy Button success URL to include session_id so this page can confirm the order.'
                    : status === 'error'
                        ? 'If your payment went through, Stripe will email a receipt. The server-side Meta Purchase event is sent from the Stripe webhook.'
                        : 'Please wait while we confirm your Stripe checkout.';

    return (
        <div className="max-w-3xl mx-auto px-4 py-16 text-center">
            <h1 className="text-3xl font-bold mb-4">{heading}</h1>
            <p className="text-gray-600 mb-8">{message}</p>
            <Link
                to="/Purchase"
                className="inline-block bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-lg"
            >
                Back to EpiQCase
            </Link>
        </div>
    );
}

export default PurchaseSuccess;
